import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { ThemeService } from '@/services/theme.service';
import { LoadingService } from '@/services/loading.service';
import { SessionService } from '@/services/session.service';
import { AuthService } from '@/services/auth.service';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
@Component({
  selector: 'app-root',
  template: `<app-loading-full-screen [show]="show" [text]="text"></app-loading-full-screen>
    <router-outlet> </router-outlet>`,
})
export class AppComponent implements OnDestroy {

  private destroy$ = new Subject<void>();

  public show = false;
  public text = '';

  constructor(
    private loadingService: LoadingService,
    private themeService: ThemeService,
    private sessionService: SessionService,
    private authService: AuthService,
    private router: Router,
    private cdr: ChangeDetectorRef) {

    this.themeService.init();
  
    /*if(!token) {
      this.router.navigateByUrl('/auth/login');
    }*/
    //this.checkLoggedUserAuthorization();

    this.loadingService.loadingEvent$
      .pipe(takeUntil(this.destroy$))
      .subscribe((item: string) => {
        if (item !== '') {
          this.show = true;
          this.text = item;
        } else {
          this.show = false;
          this.text = '';
        }
        this.cdr.detectChanges();
    });
  }

  private checkLoggedUserAuthorization() {
    if(this.sessionService.Logged()) {
      const token = this.sessionService.getToken();
      if(token?.userToken) {
        this.authService.setRolesAndPermissions(token?.userToken.claims);
      } else {
        this.sessionService.logout();  
      }
    } else {
      this.sessionService.logout();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
